import React, { useEffect } from 'react';
import Faq, { publisherFaqs } from '../../shared/faq/Faq';
import AgentPublishing from './agentPublishing/AgentPublishing';
import PublisherBanner from './publisherBanner/PublisherBanner';
import Footer from '../../shared/footer/Footer';
import Header from '../../shared/header/Header';

const Publisher = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <>
      <Header />
      <PublisherBanner />
      <AgentPublishing />
      <Faq faqs={publisherFaqs} />
      <Footer />
    </>
  );
};

export default Publisher;
